import { URL } from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { CONSTANT } from "../../utils/Constants";

export interface RoleWarehouses {
  roleId: number;
  warehouseIds: number[];
}

// Bodegas con las que puede trabajar un perfil (INVENTORY_API). Lista vacía = todas.
export const getRoleWarehouses = async (
  roleId: number
): Promise<RoleWarehouses> => {
  const response = await privateFetch.get(URL.REQUEST_ROLE_WAREHOUSE(roleId));
  return response.data;
};

// Reemplaza las bodegas del perfil. Sólo el Administrador puede hacerlo.
export const saveRoleWarehouses = async (
  roleId: number,
  warehouseIds: number[],
  user: string
): Promise<RoleWarehouses> => {
  const response = await privateFetch.put(
    URL.REQUEST_ROLE_WAREHOUSE(roleId),
    JSON.stringify({ warehouseIds, user }),
    { headers: { ...CONSTANT.HEADER_TYPE } }
  );
  return response.data;
};
